import getCsrfToken from '../csrf_token';
import getValue, { getVersion } from '../ab_tests';

const testName = 'view_restriction_without_subscription_after_five';

export default async function getViewRestrictionAssignment(required = false) {
  const value = getValue(testName);
  const version = getVersion(testName);
  if (value) {
    return [value, version];
  }

  if (!required) {
    return [null];
  }

  const token = await getCsrfToken();

  const response = await fetch('/ab_tests/view_restriction', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'X-CSRF-Token': token,
    },
  });

  if (response.ok) {
    const body = await response.json();

    if (body.amplitude_name) {
      identifyUser(body.amplitude_name, body.value);
    }

    return [body.value, body.amplitude_name.split(':')[1] | 0];
  }

  throw new Error('failed to get an assignment');
}

function identifyUser(name, value) {
  if (typeof amplitude !== 'undefined') {
    const identity = new amplitude.Identify();
    identity.set(name, value);

    amplitude.getInstance().identify(identity);
  }
}
